import { Component, Input, OnInit } from '@angular/core';
import {
  ProductionOrderIdentifier,
  ResultsDelivery,
  ResultsDeliveryService,
} from '@compumark/analyst-selection-tool-client';
import { Observable } from 'rxjs';
import { TaskType } from '@compumark/analyst-selection-tool-client';
@Component({
  selector: 'app-task-details',
  standalone: false,
  templateUrl: './task-details.component.html',
  styleUrls: ['./task-details.component.scss'],
})
export class TaskDetailsComponent implements OnInit {
  @Input() productionOrderIdentifier?: ProductionOrderIdentifier;
  @Input() taskType!: string;
  private supportedTaskTypes: TaskType[] = [
    'SELECTION',
    'QUALITY',
    'WCL',
    'WCL_QUALITY',
    'CCLA',
  ];

  data$: Observable<ResultsDelivery> = new Observable<ResultsDelivery>();

  constructor(private resultsDeliveryService: ResultsDeliveryService) {}

  ngOnInit(): void {
    this.data$ =
      this.resultsDeliveryService.getResultsDeliveryByProductionOrderIdentifier(
        this.productionOrderIdentifier?.productionOrderNumber!,
        this.productionOrderIdentifier?.productionOrderSequenceNumber!,
      );
  }

  refresh(): boolean {
    return false;
  }

  supported(): boolean {
    return this.supportedTaskTypes.includes(this.taskType as TaskType);
  }

  isPOCARegisterIncluded(resultsDelivery: ResultsDelivery): boolean {
    return resultsDelivery.components!.includes('POCA');
  }
}
